/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

const getSessionAuthState = () => {
  return JSON.parse(sessionStorage.getItem('authState'))
}

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const formatAndRoundPrize = (prize) => {
  const prizeWrapper = {
    amount: '',
    suffix: ''
  }
  switch (true) {
    case prize < 1e3:
      prizeWrapper.amount = ''
      prizeWrapper.suffix = ''
      break
    case prize >= 1e3 && prize < 1e6:
      prizeWrapper.amount = Math.floor(prize / 1e3)
      prizeWrapper.suffix = 'Thousand'
      break
    case prize >= 1e6 && prize < 1e9:
      prizeWrapper.amount = Math.floor(prize / 1e6)
      prizeWrapper.suffix = 'Million'
      break
    case prize >= 1e9 && prize < 1e12:
      prizeWrapper.amount = Math.floor(prize / 1e9)
      prizeWrapper.suffix = 'Billion'
      break
    case prize >= 1e12:
      prizeWrapper.amount = Math.floor(prize / 1e12)
      prizeWrapper.suffix = 'Trillion'
      break
    default:
      return prizeWrapper
  }

  return prizeWrapper
}

const detectMacOs = () => {
  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
}

const detectLinuxBaseOS = () => {
  return /android/.test(navigator.platform.toLowerCase()) || /linux/.test(navigator.platform.toLowerCase())
}

const detectNumberCount = (number) => {
  switch (number.length) {
    case 1:
      return { left: 18, top: 18 }
    case 2:
      return { left: -5, top: detectMacOs() ? 1 : 4 }
    case 3:
      return { left: -5, top: detectMacOs() ? 1 : 4 }
    default: return 0
  }
}

export {
  getSessionAuthState,
  numberWithCommas,
  formatAndRoundPrize,
  detectMacOs,
  detectNumberCount,
  detectLinuxBaseOS
}
